import React, { useState } from 'react';
import { useApp } from '../hooks/AppContext';

export default function Login() {
  const { login, loading, error } = useApp();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError('');
    try {
      await login(username.trim(), password);
    } catch (err) {
      setLocalError(err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-icon">🏪</div>
        <h1>Godown Rent</h1>
        <p className="login-sub">Confirmation System</p>

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter username"
              autoFocus
              required
            />
          </div>
          <div className="field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          {(localError || error) && (
            <div className="error-msg">{localError || error}</div>
          )}

          <button type="submit" className="btn btn-p btn-full" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
